import { NetFetch } from '../Net/NetFetch';
import { UnauthorizedError } from './Error/UnauthorizedError';
import { StatusCodes } from './Status/StatusCodes';
/**
 * Devices admin API. Single endpoint /json/devices/list — read-only for now,
 * gated by RightUsers.users_read.
 */
export class Devices {
    static async getList() {
        var _a;
        const result = await NetFetch.postData('/json/devices/list', {});
        if ((result === null || result === void 0 ? void 0 : result.statusCode) === StatusCodes.UNAUTHORIZED) {
            throw new UnauthorizedError();
        }
        if ((result === null || result === void 0 ? void 0 : result.statusCode) === StatusCodes.OK) {
            return (_a = result.list) !== null && _a !== void 0 ? _a : [];
        }
        return [];
    }
}
